<template>
    <b-row>
        <b-col class="mr-2 ml-2  OTJobStatus OTJobStatusJobs">
            <span class="OTJobStatusLabel">Total Job(s)</span>
            <span class="OTJobStatusData">{{totalJobs}}</span>
        </b-col>
        <!-- Running -->
        <b-col class="mr-2 ml-2  OTJobStatus OTJobStatusRunning">
            <span class="OTJobStatusLabel">Running Job(s)</span>
            <span class="OTJobStatusData">{{totalRunningJobs}}</span>
        </b-col>
        <!-- stop -->
        <b-col class="mr-2 ml-2  OTJobStatus OTJobStatusFailed">
            <span class="OTJobStatusLabel">Failed Job(s)</span>
            <span class="OTJobStatusData">{{totalFailedJobs}}</span>
        </b-col>
    </b-row>
</template>

<script>
import Jobs from "@/collections/jobs.js";

export default {
    data() {
        return {
            totalJobs: 0,
            totalRunningJobs: 0,
            totalFailedJobs: 0
        };
    },

    computed: {
       
        connecting() {
            return this.$store.state.socket.connecting;
        },

        connected() {
            return this.$store.state.socket.connected;
        },

        reconnecting() {
            return this.$store.state.socket.reconnecting;
        }
    },

    mounted() {
        const jobs = new Jobs();
        jobs.fetch({
            params: {
                limit: 1
            }
        })
            .then(() => {
                this.totalJobs = jobs.total_count;
                jobs.setFilter("status", "Running");
                return jobs.fetch({
                    params: {
                        limit: 1
                    }
                });
            })
            .then(() => {
                this.totalRunningJobs = jobs.total_count;
            });

        const failedjobs = new Jobs();
        failedjobs.setFilter("status", "Failed");
        failedjobs
            .fetch({
                params: {
                    limit: 1
                }
            })
            .then(() => {
                this.totalFailedJobs = failedjobs.total_count;
            });
    }
};
</script>

